import './style/index.less';
import UpgradePane from './UpgradePane';

export default UpgradePane;
